var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkillsFigma(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.667,
    height: 46,
    viewBox: "0 0 30.667 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "skills_figma",
    transform: "translate(-241 -913)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path0_fill",
    d: "M7.667,215.333a7.669,7.669,0,0,0,7.667-7.667V200H7.667a7.667,7.667,0,1,0,0,15.333Z",
    transform: "translate(241 743.667)",
    fill: "#5637fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1_fill",
    d: "M0,107.667A7.669,7.669,0,0,1,7.667,100h7.667v15.333H7.667A7.669,7.669,0,0,1,0,107.667Z",
    transform: "translate(241 828.333)",
    fill: "#5637fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1_fill_1_",
    d: "M0,7.667A7.669,7.669,0,0,1,7.667,0h7.667V15.333H7.667A7.669,7.669,0,0,1,0,7.667Z",
    transform: "translate(241 913)",
    fill: "#5637fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2_fill",
    d: "M100,0h7.667a7.667,7.667,0,0,1,0,15.333H100Z",
    transform: "translate(156.333 913)",
    fill: "#5637fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3_fill",
    d: "M115.333,107.667A7.667,7.667,0,1,1,107.667,100,7.669,7.669,0,0,1,115.333,107.667Z",
    transform: "translate(156.333 828.333)",
    fill: "#5637fa"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsFigma);
export default __webpack_public_path__ + "static/media/skills_figma.ca8401d49d2785f53c7ba2f3af505265.svg";
export { ForwardRef as ReactComponent };